module.exports = __webpack_public_path__ + "static/media/DQGSMRelationship.d104f902.png";